<script lang="ts">
    
    import type { Route } from "../global";
    import MapPath from "./MapPath.svelte";
    import Marker from "./Marker.svelte";

    export let route: Route;
    export let color: string;
    export let isActive = false;

    const [init] = route.checkpoints; 
    const [end] = route.checkpoints.slice(-1);

</script>

<Marker coordinates={init.lonLat} zIndex={isActive ? 2 : 1} anchor={isActive ? "bottom" : 'center'} offset={isActive ? [0, 5] : undefined}>
    {#if isActive}
        <img src="/images/start-marker.svg" alt="">
    {:else}
        <div class="point"></div>
    {/if}
</Marker>
<Marker coordinates={end.lonLat} zIndex={isActive ? 2 : 1} anchor={isActive ? "bottom-left" : 'center'} offset={isActive ? [-10, 5] : undefined}>
    {#if isActive}
        <img src="/images/finish-marker.svg" alt="">
    {:else}
        <div class="point"></div>
    {/if}
</Marker>
{#each route.paths as path}
    <MapPath
        path={path.coordinates}
        {color}
        on:click
        text={route.name}
        width={6}
        opacity={isActive ? 1 : 0.5}
        drawBefore={isActive ? 'high-layer' : 'low-layer'} />
{/each}

<style lang="scss">

    @use '../variables';

    .point {
        $size: 20px;

        width: $size;
        height: $size;
        background-color: variables.$color-primary;
        border: 3px solid #fff;
        border-radius: 50%;
    }

</style>
